export default __webpack_public_path__ + "static/media/backend (1).81319940.png";